<template>
  <div class="container">
    <!-- main title -->
    <div class="main-title">
      <h2>افزودن برنامه</h2>
    </div>
    <!-- end main title -->

    <!-- form -->
    <div class="form-container" v-if="loaded">
      <div class="form-row">
        <CInput v-model="mobile" label="موبایل کاربر"/>
        <CInput v-model="user_name" label="نام کاربر"/>
        <CInput v-model="plan_name" label="نام برنامه"/>
      </div>
      <div class="form-row">
        <CTextarea v-model="plan_summary" label="توضیحات برنامه" :rows="3"/>
      </div>
      <div class="form-row">
        <h3>روزهای برنامه</h3>
      </div>
      <div class="day-container" v-for="(day, index) in days" :key="'season'+index">
        <div class="flex items-center gap-4">
          <div class="w-1/2">
            <p class="mb-2">عنوان روز</p>
            <CInput v-model="day.title"/>
          </div>
          <button @click="selected_day = index; dialog_plans = true" type="button" class="form-btn2 mt-3">
            برنامه تمرینی
          </button>
          <div class="day-actions">
            <button @click="days.push({ plans: [{}] })" type="button" class="form-btn mt-3">
              <img class="w-4" src="/img/plus.svg" alt="">
            </button>
            <button @click="days.splice(index, 1)" v-if="days.length > 1" type="button"
                    class="form-btn2 mt-3 bg-red-600 mr-1">
              حذف روز
            </button>
          </div>
        </div>
      </div>
      <button @click="add_plan()"  type="button"
              class="form-btn2 mt-3 bg-red-600 mr-1">
        ثبت برنامه
      </button>
    </div>
    <!-- end form -->

    <!-- modal for adding exercise plans -->
    <CModal v-model="dialog_plans" title="افزودن برنامه تمرینی">
      <div class="px-4" v-for="(plan, index) in days[selected_day].plans" :key="index">
        <div class="plan-row grid grid-cols-12">
          <treeselect
              class="col-span-2"
              :async="true"
              v-model="plan.link"
              :load-options="load_uploader"
              :normalizer="normalizer_uploader"
              placeholder="جستجو لینک"
              :searchable="true"
              :load-root-options="true"
              :auto-load-root-options="true"
              :clear-on-select="false"
              :show-count="true"
              :always-open="false"
              :default-expand-level="1"
              :min-input-length="0"
              :delay="0"
              :loading-text="'در حال جستجو...'"
              :no-options-text="'موردی یافت نشد'"
              :no-results-text="'موردی یافت نشد'"
          />
          <div class="col-span-3 mt-4">
            <CInput v-model="plan.title" placeholder="عنوان برنامه"/>
          </div>
          <div class="col-span-5 mt-4">
            <CInput v-model="plan.summary" placeholder="توضیحات برنامه"/>
          </div>
          <div class="plan-actions col-span-2">
            <button @click="days[selected_day].plans.push({})" type="button" class="form-btn2">
              افزودن برنامه
            </button>
            <button @click="days[selected_day].plans.splice(index, 1)" v-if="days.length > 1" type="button"
                    class="form-btn2">
              حذف برنامه
            </button>
          </div>
        </div>
      </div>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import CInput from "@/views/CustomComponent/CInput.vue";
import CTextarea from "@/views/CustomComponent/CTextarea.vue";
import CModal from "@/views/CustomComponent/CModal.vue";
import Treeselect, {ASYNC_SEARCH} from 'vue3-treeselect';
import 'vue3-treeselect/dist/vue3-treeselect.css';

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200);
};

export default {
  name: 'AddProgram',
  components: {
    Treeselect,
    CModal,
    CTextarea,
    CInput,
  },
  data() {
    return {
      loaded: true,
      mobile: '',
      user_name: '',
      plan_name: '',
      plan_summary: '',
      days: [
        {plans: [{}]}
      ],
      selected_day: 0,
      dialog_plans: false,
      status_form:0,
    };
  },
  mounted() {
    if(this.$route.params.id!=null){
      this.loaded = false
      this.status_form = this.$route.params.id
      this.get_plan_info();
    }
  },
  methods: {
    load_uploader({action, searchQuery, callback}) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          axios.post('search_upload_video', {
            search: searchQuery,
          }).then(response => {
            callback(null, response.data);
          }).catch(error => {
            console.error(error);
          });
        });
      }
    },
    normalizer_uploader(node) {
      return {
        id: node.url,
        label: node.title,
      };
    },

    add_plan() {

      var self = this;

      var formData = new FormData();
      var url = ""
      if (this.status_form == 0) {
        url = "insert_user_plan";
      } else {
        url = "edit_user_plan"
        formData.append("id", this.status_form)

      }
      formData.append("mobile", this.mobile)
      formData.append("user_name", this.user_name)
      formData.append("plan_name", this.plan_name)
      formData.append("plan_summary", this.plan_summary)
      formData.append("days", JSON.stringify(this.days))

      this.axios.post(url, formData, {}).then(function (response) {

        if(response.data.error==0){
          self.$router.push({path: '/plans/list'})
        }


      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا در ثبت اطلاعات');
      });


    },
    get_plan_info() {

      var self = this;

      var formData = new FormData();
      var url = ""
        url = "get_admin_plan_info";

        formData.append("id", this.status_form)


      this.axios.post(url, formData, {}).then(function (response) {

var data = response.data.data
        self.mobile= data.user.phone
            self.user_name= data.user.name
            self.plan_name= data.title
            self.plan_summary= data.summary
        self.days =[]
        data.seasons.forEach(function (val){
          var day = {}
          day.title = val.title
          day.plans = []
          val.episodes.forEach(function (episode){
            day.plans.push({
              link:episode.link,
              title:episode.title,
              summary:episode.summary
            })
          })
          self.days.push(day)
        })
        self.loaded = true


      }).catch(function (error) {
        console.log(error);
        self.$toast.error('خطا در ثبت اطلاعات');
      });


    },

  },
};
</script>

<style>

.form__input {
  background-color: #151f30 !important;
  border-color: #383f4c !important;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.main-title {
  text-align: center;
  margin-bottom: 20px;
}

.form-container {
  background-color: #181f2e;
  padding: 20px;
  border-radius: 8px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}

.day-container {
  margin-bottom: 20px;
}

.day-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.day-actions {
  display: flex;
  gap: 10px;
}


.plan-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.plan-actions {
  display: flex;
  gap: 10px;
}

.form-btn {
  padding: 12px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-btn2 {
  padding: 8px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
}

.form-btn:hover {
  background-color: #0056b3;
}
</style>